import Env from '@/env/env'

/**
 * Serves an external image through our API instead of requesting the CDN
 * directly.
 *
 * Brave and ad blockers refuse third-party requests to LinkedIn's CDN, so the
 * image never arrives — not for display, and not for the copy attached to the
 * report either, since that is a `fetch` of the same URL. Asking our own domain
 * for it stops being a third-party request.
 *
 * The bytes are identical: the API fetches the same URL and streams it back.
 * It can only do that for hosts the API itself can reach, so check before
 * sending a new one through here.
 */
export const proxiedImageUrl = (url?: string | null): string | undefined => {
  // The LinkedIn search returns a path fragment instead of a URL for some
  // results. Left alone the browser resolves it against our own origin and gets
  // index.html back with a 200, so the image renders broken rather than falling
  // back to the subject's initials.
  if (!url || !/^https?:\/\//i.test(url)) return undefined

  return `${
    Env.REACT_APP_BASE_API_URL
  }/api/v1/internal/subject/image?url=${encodeURIComponent(url)}`
}
